<template>
    <div class="folder_card" v-for="index in $store.state.pageShimmerSize" :key="index">
        <div class="card-bodyx_shimmarxx d-flex shimmer-line shimmer shimmer-animate mb-2 flex-column" > 
            <div class="d-flex w-100" style="margin-bottom:5px">
                <div class="icon-small shimmer-line shimmer shimmer-animate" style="width:90%;"></div>
            </div>
            <div class="newfilesection_image w-100">
                <div class="mb-4 text-center p-3 rounded iq-thumb"><i class="shimmer-line shimmer shimmer-animate"></i></div>
            </div>                    
        </div>
    </div>
</template>
<script>
export default {
    name: 'ShimmerFileComponent'
}
</script>